import Icon from '@material-ui/icons/Public';
import { ListGuesser } from 'react-admin';
import { PageList } from './PageList';

export default {
  icon: Icon,
  list: PageList,
};
